import { apiCall } from './common.js';

export const apiGetBranchesList = (params) => apiCall({ endpoint: 'v1/branches', method: 'GET', params });
export const apiGetBranch = (version) => apiCall({ endpoint: `v1/branch/${version}`, method: 'GET' });
export const apiCreateBranch = (data) => apiCall({ endpoint: 'v1/branch', method: 'POST', body: data });
export const apiUpdateBranch = (version, data) => apiCall({ endpoint: `v1/branch/${version}`, method: 'PATCH', body: data });
export const apiDeleteBranch = (version) => apiCall({ endpoint: `v1/branch/${version}`, method: 'DELETE' });
export const apiTriggerCreateBranch = (version, data) => apiCall({ endpoint: `v1/branch/${version}/create-branch`, method: 'POST', body: data });
export const apiGetAllClusters = () => apiCall({ endpoint: `v1/branches/all-clusters`, method: 'GET' });
